import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePekerjaanListModel} from "@/stores/models/pekerjaan-list-model";

export const usePekerjaanListStore  = defineStore(
    'pekerjaanListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourcePekerjaanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePekerjaanListModel().pekerjaanListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePekerjaanList = (additionalParams = null) => {
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePekerjaanListModel().pekerjaanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePekerjaanList.value.reload();
        };

        const initialized = ()=>{     
            dataSourcePekerjaanList.value.reload();
        };

        return {
            dataSourcePekerjaanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);